import React from "react";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import cashIcon from "../../../images/gameplay_ui/icons/cash_icon.svg";
import AddRemoveButtons from "../AddRemoveButtons";
import GameButtonWithText from "../GameButtonWithText";
import agent from "../../../agent";
import {GetSparePartCost} from "../../../gameplay/model/Balance";
import GameData from "../../../gameplay/model/GameData";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import x from "../../../images/icons/close_red.svg";

export default class BuyPartsPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0
    }

    let economyIndex = UtilsFunctions.getRoleNameIndex("Зам. по экономике и финансам");
    this.isFinanceDirector = UtilsFunctions.playerHasRole(economyIndex);
  }

  addParts(diff) {
    this.setState({
      count: diff
    })
  }

  buyParts() {
    if (!this.isFinanceDirector) {
      alert("Покупать запчасти может только Зам. по экономике и финансам");
      return;
    }

    agent.GamePlay.buyParts(this.props.teamID, {
      repairShopId: this.props.id,
      count: this.state.count
    }, response => {
      console.log(response);
      this.props.onClose(this);
    });
  }

  render() {
    let bgStyle = {
      zIndex: "10",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      width: "184px",
      height: "150px",
      padding: "5px",
      borderRadius: "3px",
      background: "#F2F2F2"
    }
    let posStyle = this.props.isRight ? {left: "10px"} : {right: "10px"};

    return <div style={{...bgStyle, ...posStyle}}>
      <CurrencyCard icon={this.props.icon} value={"Запчасти"} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <img src={x} alt="X" className="x" onClick={() => {
        this.props.onClose(this)
      }}/>
      <CurrencyCard icon={cashIcon} value={2000000} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <AddRemoveButtons
        asInputNumber={true}
        max={Math.floor(GameData.CurrentGame.cash / GetSparePartCost())}
        width={130}
        value={this.state.count}
        onValueChanged={this.addParts.bind(this)}
        isCanBuy={this.isFinanceDirector && (this.state.count + 1) * GetSparePartCost() <= GameData.CurrentGame.cash}
        isCanSell={this.isFinanceDirector && this.state.count > 0}
      />
      <GameButtonWithText width={164}
                          height={30}
                          colorStart={"#8CED00"}
                          colorEnd={"#66AE04"}
                          title={"КУПИТЬ"}
                          disabled={!this.isFinanceDirector || this.state.count === 0}
                          onClick={this.buyParts.bind(this)}
      />
    </div>
  }
}
